import apiClient from './apiClient';

/**
 * Onboarding-Status abrufen
 */
export const getOnboardingStatus = async () => {
  const response = await apiClient.get('/onboarding/status');
  return response.data;
};

/**
 * Liste aller verfügbaren Branchen abrufen
 */
export const getBranchen = async () => {
  const response = await apiClient.get('/onboarding/branchen');
  return response.data;
};

/**
 * Standard-Einstellungen für eine Branche abrufen
 */
export const getBranchenDefaults = async (branche) => {
  const response = await apiClient.get(`/onboarding/branchen/${branche}/defaults`);
  return response.data;
};

/**
 * Onboarding-Schritt speichern
 */
export const saveOnboardingStep = async (step, data) => {
  const response = await apiClient.post(`/onboarding/step/${step}`, data);
  return response.data;
};

/**
 * Onboarding abschließen
 */
export const completeOnboarding = async () => {
  const response = await apiClient.post('/onboarding/complete');
  return response.data;
};

/**
 * Onboarding überspringen
 */
export const skipOnboarding = async () => {
  const response = await apiClient.post('/onboarding/skip');
  return response.data;
};

/**
 * System-Prompt Vorschau generieren
 */
export const generatePromptPreview = async (data = {}) => {
  const response = await apiClient.post('/onboarding/generate-prompt', data);
  return response.data;
};

/**
 * Onboarding zurücksetzen
 */
export const resetOnboarding = async () => {
  const response = await apiClient.post('/onboarding/reset');
  return response.data;
};

/**
 * Branchen-Icons abrufen (öffentlicher Endpunkt)
 * Gibt eine Map mit brancheCode -> iconPath zurück
 */
export const getBrancheIcons = async () => {
  const response = await apiClient.get('/onboarding/branche-icons');
  return response.data;
};
